import React, { FC } from 'react'

const Dashboard: FC<unknown> = () => {
  return <div>There&apos;s nothing here yet. Check out Users and Things.</div>
}

export default Dashboard
